import { createReactiveVar } from './create-reactive-var';

export const {
  setter: setShowNotEnoughProfileError,
  useHook: useShowNotEnoughProfileError,
} = createReactiveVar<boolean>(false);

export const {
  setter: setHasEnoughProfileData,
  useHook: useHasEnoughProfileData,
} = createReactiveVar<boolean | undefined>(undefined);
export const {
  setter: setAIEarnMoreDialogSalary,
  useHook: useAIEarnMoreDialogSalary,
} = createReactiveVar<number | null>(null);
export const {
  setter: setForceAIEarnMoreQuery,
  useHook: useForceAIEarnMoreQuery,
} = createReactiveVar<boolean>(false);
